// extracted by mini-css-extract-plugin
export default {"iconDefault":"View_iconDefault__x7sCn"};